export default __webpack_public_path__ + "static/media/infobanner2.fb2d1e65.svg";